<template>
    <div>
        <fade-and-slide
            ><div :class="$style['offline-box']" v-if="offline">
                {{ labels.frontendProductpage.specs.connectionIssues }}
            </div></fade-and-slide
        >
    </div>
</template>

<style module>
.offline-box {
    padding: 7px;
    background: #dc3545;
    box-sizing: border-box;
    color: white;
    font-weight: bold;
    text-align: center;
    white-space: pre;
}
</style>

<script lang="ts" setup>
import { computed, ref } from "vue";
import * as networkState from "../../../../utilities/network-state";
import FadeAndSlide from "../../shared/FadeAndSlide.vue";
import labels from "../../shared/labels";
import { onConnectionChange } from "../../../../web-workers/auction-socket";


const socketOffline = ref(false);
const networkOffline = ref(false);
const socketListenerInit = ref(false);

const offline = computed(() => {
    return socketOffline.value === true || networkOffline.value === true;
});

// watch(
//     () => offline.value,
//     (newValue) => {
//         console.debug("detected", newValue ? "offline" : "online");
//     }
// );

function ensureInitSocket() {
    if (socketListenerInit.value === true) return;

    {
        socketListenerInit.value = true;
        onConnectionChange((v) => {
            // console.debug("has netvork socket: " + v);
            socketOffline.value = !v;
        });
        return;
    }

    requestAnimationFrame(() => {
        setTimeout(() => {
            ensureInitSocket();
        }, 100);
    });
}

ensureInitSocket();
networkState.onChange((v) => {
    networkOffline.value = v.type === "offline";
});
</script>
